module.exports = __webpack_public_path__ + "img/tj.be7a3e59.png";